<template>
  <div v-if="electiveData.length > 0" class="overflow-hidden">
    <NavigationView :widget_id="this.elecFaq.widget_id" />
    <!--banner-->
    <!---mobBanner-->
    <div class="md:hidden">
      <div
        v-if="electiveData.length > 0"
        class="absolute top-[70px] py-22 rounded-full"
      >
        <div class="text-[12px] text-white font-medium line-clamp-1 px-5">
          <router-link :to="{ name: 'home' }" class="border-b border-[#F8C300]">
            Home
          </router-link>
          &nbsp; > &nbsp;
          <router-link
            :to="{ name: 'AllProgram' }"
            class="border-b border-[#F8C300]"
          >
            {{ electiveData[0].program.category.name }}
          </router-link>
          &nbsp; >&nbsp;
          <a
            :href="`/${electiveData[0].program.slug}`"
            class="border-b border-[#F8C300]"
          >
            {{ electiveData[0].program.short_name }}
          </a>
          &nbsp; >&nbsp;
          {{ electiveData[0].name }}
        </div>
      </div>
      <!-- <div
        class="absolute right-[6%] flex bg-gray-200 top-[2%] px-2 py-[3px] rounded-lg"
      >
        <div class="pr-2">
          <font-awesome-icon icon="fa-solid fa-share-nodes" />
        </div>
        <div class="b">Share</div>
      </div> -->
      <div class="m-auto">
        <img
          :src="this.electiveData[0].mobile_banner"
          alt="Banner.webp"
          class="m-auto"
        />
      </div>
      <div
        class="bg-gradient-to-b from-[#4B61BE] to-[#1E387E] rounded-b-2xl h-[500px] pb-6 relative"
      >
        <div class="flex gap-5 absolute top-[15px] px-5">
          <div
            class="bg-[#61A222] text-xs py-[4px] px-2 rounded-md text-white font-bold flex gap-2 whitespace-nowrap"
            v-if="this.electiveData[0].trending"
          >
            <img src="@/assets/electiveDetail/mostPopulat.svg" alt="popular" />
            Most popular elective
          </div>
          <div
            class="bg-[#C73B3C] text-xs py-[4px] px-2 rounded-md text-white font-bold flex gap-2 whitespace-nowrap"
          >
            <img src="@/assets/electiveDetail/fewSeates.svg" alt="fewSeats" />
            Only few seats left
          </div>
        </div>
        <h2
          v-if="electiveData.length > 0"
          class="pt-[2.5rem] md:pt-[1.5rem] text-start pl-6 text-2xl font-bold text-white w-[20rem]"
          v-html="electiveData[0].sub_name"
        ></h2>
        <p
          class="w-[21rem] text-white ml-6 mt-2 text-start pb-4 h-[180px]"
          v-html="electiveData[0].description"
        ></p>

        <div class="mt-2">
          <div class="flex gap-x-8 ml-6 pb-2">
            <div class="flex items-center">
              <!--  <div>
                <img
                  src="@/assets/electiveDetail/nextBatch.svg"
                  alt="nextBatch"
                />
              </div>
               <div class="text-white text-xs font-bold text-start pl-2">
                Batch Start -->

              <!-- {{ formatDatebanner(electiveData[0].next_batch) }} -->
              <!-- Admissions Closing Soon!
                 -->
              <!-- <p class="text-md text-white">
                  Batch Starts:<br>
                  <span class="text-yellow-500 font-semibold"
                    >March 23rd, 2025</span
                  >
                </p> 
              </div>-->
              <div>
                <img
                  src="@/assets/electiveDetail/JO--Credits.png"
                  alt="multimediaContent"
                  width="30"
                />
              </div>
              <div class="text-white text-xs font-bold text-start pl-2">
                Program Credits
                <br />
                {{ credit }}
              </div>
            </div>
            <div class="flex items-center ml-4">
              <div>
                <img
                  src="@/assets/electiveDetail/Duration.svg"
                  alt="duration"
                />
              </div>
              <div class="text-white text-xs font-bold text-start pl-2">
                Duration
                <br />
                {{ electiveData[0].duration }} years
              </div>
            </div>
          </div>
          <div class="flex gap-x-6 pt-4 pb-4 mt-2 ml-6">
            <div class="flex items-center">
              <div>
                <img
                  src="@/assets/electiveDetail/fees.svg"
                  alt="multimediaContent"
                />
              </div>
              <div class="text-white text-xs font-bold text-start pl-2">
                {{ feeLabel }}
                <br />
                {{ formatCurrency(electiveData[0].program_fee) }}
              </div>
            </div>
            <div class="flex items-center ml-4">
              <div>
                <img
                  src="@/assets/electiveDetail/eligiblity.svg"
                  alt="multimediaContent"
                />
              </div>
              <div class="text-white text-xs font-bold text-start pl-2">
                Eligibility
                <br />
                {{ electiveData[0].eligibility }}
              </div>
            </div>
          </div>
          <!-- <div class="flex gap-x-6 pb-4 ml-2">
            <div class="flex items-center ml-4">
              <div>
                <img
                  src="@/assets/electiveDetail/JO--Credits.png"
                  alt="multimediaContent"
                  width="30"
                />
              </div>
              <div class="text-white text-xs font-bold text-start pl-2">
                Program Credits
                <br />
                {{ credit }}
              </div>
            </div>
          </div> -->
        </div>
        <div class="flex justify-center left-10 gap-3 mt-6 absolute -bottom-7">
          <div
            class="bg-[#F8C300] font-bold text-[#001C54] rounded-full cursor-pointer flex justify-center items-center text-xs px-6 py-4"
            @click="handleApplyNowClick"
          >
            Apply Now
          </div>
          <!-- <div
            class="border border-[#001C54] px-6 py-2 bg-[#FFFFFF] text-[#001C54] font-bold rounded-full cursor-pointer"
            @click="scroll"
          >
            Read More
          </div> -->
          <div
            v-if="electiveData[0].brochure_url"
            @click="handleDownloadClick"
            class="bg-[#F8C300] w-[10rem] m-auto rounded-full py-3 px-10 text-xs font-bold cursor-pointer"
          >
            Download Brochure
          </div>
        </div>
      </div>
    </div>
    <!---mobBanner-->
    <!--desktopBanner-->
    <div class="2xl:h-[41rem]">
      <div
        class="2xl:bg-gradient-to-b 2xl:from-[#05225E] 2xl:to-[#183883] lg:h-[34rem]"
      >
        <div class="md:flex hidden 2xl:max-w-screen-2xl m-auto">
          <div
            class="w-[50%] lg:w-[50%] bg-gradient-to-b from-[#05225E] to-[#183883] rounded-bl-3xl h-[34rem] p-2 relative"
          >
            <!-- Apply Now Button -->
            <div class="absolute -bottom-5 flex gap-2 left-10">
              <div
                class="px-6 py-2 bg-[#F8C300] font-bold text-[#001C54] rounded-full cursor-pointer"
                @click="handleApplyNowClick"
              >
                Apply Now
              </div>
              <!-- <div
                class="bg-[#FFFFFF] border-[1px] border-[#001C54] w-[160px] px-4 py-2 rounded-full font-bold cursor-pointer"
                @click="scroll"
              >
                Read more
              </div> -->
              <div
                v-if="electiveData[0].brochure_url"
                @click="handleDownloadClick"
                class="bg-[#F8C300] w-[15rem] m-auto rounded-full py-3 px-16 lg:px-10 lg:text-xs xl:text-[16px] font-bold mt-4 lg:mt-0 cursor-pointer"
              >
                Download Brochure
              </div>
            </div>
            <div class="text-start text-white ml-8 pt-2 text-[13px] mt-4">
              <div v-if="electiveData.length > 0">
                <router-link
                  :to="{ name: 'home' }"
                  class="border-b border-[#F8C300]"
                >
                  Home
                </router-link>
                &nbsp; > &nbsp;
                <router-link
                  :to="{ name: 'AllProgram' }"
                  class="border-b border-[#F8C300]"
                >
                  {{ electiveData[0].program.category.name }}
                </router-link>
                &nbsp; >&nbsp;
                <a
                  :href="`/${electiveData[0].program.slug}`"
                  class="border-b border-[#F8C300]"
                >
                  {{ electiveData[0].program.short_name }}
                </a>
                &nbsp; >&nbsp;
                {{ electiveData[0].name }}
              </div>
            </div>
            <div class="flex gap-5 ml-8 mt-6 mb-4">
              <div
                class="bg-[#61A222] text-xs py-[4px] px-2 rounded-md text-white font-bold flex gap-2 whitespace-nowrap"
                v-if="this.electiveData[0].trending"
              >
                <img
                  src="@/assets/electiveDetail/mostPopulat.svg"
                  alt="popular"
                />
                Most popular elective
              </div>
              <div
                class="bg-[#C73B3C] text-xs py-[4px] px-2 rounded-md text-white font-bold flex gap-2 whitespace-nowrap"
              >
                <img
                  src="@/assets/electiveDetail/fewSeates.svg"
                  alt="fewSeats"
                />
                Only few seats left
              </div>
            </div>
            <h1
              v-if="electiveData.length > 0"
              class="text-white text-2xl lg:text-3xl 2xl:text-4xl font-bold text-start ml-8 mt-2"
              v-html="electiveData[0].sub_name"
            ></h1>
            <p
              class="text-white text-sm lg:text-base text-start ml-8 line-clamp-5 md:pr-10"
              v-html="electiveData[0].description"
            ></p>
            <div
              class="border-b-[1px] border-silver-100 w-[20rem] lg:w-[25rem] relative top-2 xl:top-4 left-8"
            ></div>
            <div class="lg:ml-6 xl:ml-0 xl:pt-[.5rem]">
              <div
                class="flex justify-around xl:justify-start xl:px-8 2xl:px-10 mb-4 lg:mt-5 ml-4 lg:ml-[5px]"
              >
                <!-- Admissions Closing Soon! -->
                <!-- Batch Start -->
                <!-- <div class="flex items-center lg:w-[50%]">
                
                  <div>
                    <img
                      src="@/assets/electiveDetail/nextBatch.svg"
                      alt="nextBatch"
                    />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >

                     {{ formatDatebanner(electiveData[0].next_batch) }}
                    <p class="text-md text-white">
                      Batch Starts:
                      <span class="text-yellow-500 font-semibold"
                        >March 23rd, 2025</span
                      >
                    </p>
                  </div>
                </div> -->
                <div class="flex items-center lg:w-[50%]">
                  <div>
                    <img
                      src="@/assets/electiveDetail/JO--Credits.png"
                      alt="credit"
                      width="30"
                    />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >
                    Program Credits
                    <br />
                    <p class="w-[5rem] lg:w-max">
                      {{ this.credit }}
                    </p>
                  </div>
                </div>
                <div class="flex items-center lg:w-[50%">
                  <div>
                    <img
                      src="@/assets/electiveDetail/Duration.svg"
                      alt="duration"
                    />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >
                    Duration
                    <br />
                    {{ electiveData[0].duration }} years
                  </div>
                </div>
              </div>
              <div
                class="flex justify-around xl:justify-start xl:px-8 2xl:px-10 mt-4 mb-4 lg:mt-5 ml-4 lg:ml-0"
              >
                <div class="flex items-center lg:w-[50%]">
                  <div>
                    <img src="@/assets/electiveDetail/fees.svg" alt="fees" />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >
                    <span>{{ feeLabel }}</span>
                    <br />
                    {{ formatCurrency(electiveData[0].program_fee) }}
                  </div>
                </div>
                <div class="flex items-center lg:w-[50%]">
                  <div>
                    <img
                      src="@/assets/electiveDetail/eligiblity.svg"
                      alt="eligiblity"
                    />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >
                    Eligibility
                    <br />
                    <p class="w-[5rem] lg:w-max">
                      {{ electiveData[0].eligibility }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div
                class="flex justify-around xl:justify-start xl:px-8 2xl:px-10 mt-4 mb-4 lg:mt-5 ml-4 lg:ml-0"
              >
                <div class="flex items-center lg:w-[50%]">
                  <div>
                    <img
                      src="@/assets/electiveDetail/JO--Credits.png"
                      alt="credit"
                      width="30"
                    />
                  </div>
                  <div
                    class="text-white lg:w-max text-xs lg:text-sm xl:text-base font-bold text-start pl-2"
                  >
                    Program Credits
                    <br />
                    <p class="w-[5rem] lg:w-max">
                      {{ this.credit }}
                    </p>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="w-[50%] rounded-bl-3xl">
            <div>
              <img
                :src="this.electiveData[0].banner"
                class="rounded-b-3xl h-[37rem] shadow-lg"
                alt="bannerDes"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--desktopBanner-->
    <!--banner-->
    <!--bright future-->
    <div
      class="mt-[6rem] 2xl:mt-0 mb-[4rem] md:flex md:flex-col md:justify-center md:items-center"
    >
      <h2 class="text-start px-4 text-2xl lg:text-3xl font-bold">
        A Bright Future Awaits
      </h2>
      <div class="font-base text-start px-4 pt-2 2xl:text-xl">
        {{ electiveData[0].future }}
      </div>
      <div>
        <div
          class="flex flex-col md:flex-row justify-start gap-y-4 md:gap-x-3 px-5 mt-4"
        >
          <div
            class="flex items-center bg-gradient-to-b from-[#0F2377] to-[#00102F] p-4 md:p-6 xl:p-10 rounded-xl md:w-[15rem] xl:w-[20rem]"
          >
            <div class="text-3xl md:text-4xl font-bold text-[#F8C300]">
              {{ employabilityData.firstEmployability }}
            </div>
            <div class="text-base text-white text-start pl-2">
              {{ employabilityData.secondEmployability }}
            </div>
          </div>
          <div
            class="flex items-center bg-gradient-to-b from-[#0F2377] to-[#00102F] p-4 md:p-6 xl:p-10 rounded-xl md:w-[15rem] xl:w-[20rem]"
          >
            <div
              class="text-3xl md:text-4xl justify-start text-left font-bold text-[#F8C300] max-w-[10rem]"
            >
              {{ employabilityData.firstOpenings }}
            </div>
            <div class="text-base text-white text-start pl-2">
              {{ employabilityData.secondOpenings }}
            </div>
          </div>
          <div
            class="flex items-center bg-gradient-to-b from-[#0F2377] to-[#00102F] p-4 md:p-6 xl:p-10 rounded-xl md:w-[15rem] xl:w-[20rem]"
          >
            <div class="text-3xl md:text-4xl font-bold text-[#F8C300]">
              {{ employabilityData.firstGrowth }}
            </div>
            <div class="text-base text-white text-start pl-2">
              {{ employabilityData.secondGrowth }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-4 md:flex md:flex-col md:items-center md:justify-center w-full max-w-4xl mx-auto"
      >
        <h class="text-start ml-4 text-lg xl:text-xl">Top Trending Roles</h>

        <div class="w-full flex flex-wrap justify-end">
          <div
            v-for="(data, index) in electiveData[0].trending_roles"
            :key="index"
            class="w-full md:w-[40%] pl-4 md:pl-0"
          >
            <div class="flex pl-3 pt-2">
              <img src="@/assets/electiveDetail/checked.svg" alt="checked" />
              <div class="pl-2 font-medium text-left">{{ data }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--bright future-->
    <!--Elective highlights-->
    <div class="mb-[4rem] flex flex-col px-4 max-w-7xl mx-auto" id="highlights">
      <h2 class="text-2xl font-bold text-start pb-4 lg:text-3xl">
        Elective Highlights
      </h2>
      <div
        class="flex md:flex-row md:justify-between w-full flex-wrap m-auto gap-4"
      >
        <div
          v-for="(data, index) in electiveData[0].highlight_description"
          :key="index"
        >
          <ul
            class="flex flex-col md:flex-row justify-between md:flex-wrap lg:items-center list-disc pl-6 md:pl-10"
          >
            <li
              class="text-left pb-1 md:w-[300px] lg:w-[25rem] xl:w-[30rem] text-[15px] lg:text-[20px]"
            >
              <!-- Render the data with v-html -->
              <span v-html="replaceDollarWithComma(data)"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--Elective highlights-->
    <section
      class="py-16"
      v-if="$route.path === '/online-mba/general-management'"
    >
      <h2 class="text-2xl font-bold w-[12rem] pb-5 md:w-max m-auto md:text-3xl">
        Advanced Certifications
      </h2>
      <CertificateView
        v-if="$route.path === '/online-mba/general-management'"
      />
    </section>
    <!--syllabus-->
    <div
      class="max-w-7xl m-auto md:flex md:justify-between md:items-center md:py-5"
    >
      <div class="md:px-2">
        <h2 class="text-start pl-2 text-2xl lg:text-3xl font-bold">Syllabus</h2>
        <div class="flex flex-col md:flex-row justify-between">
          <div class="mt-2 flex flex-col justify-center items-center">
            <div
              v-for="item in electiveSyllabus"
              :key="item.id"
              class="flex flex-col shadow-lg mb-4 w-[22rem] lg:w-[30rem] xl:w-[40rem] rounded-xl p-3 cursor-pointer border border-gray-100"
            >
              <div
                class="flex justify-between"
                @click="toggleAccordin(item.id)"
              >
                <div class="p-2 text-[#001C54] font-bold text-xl">
                  {{ item.semester }} Semester
                </div>

                <div v-if="!syllabusAccordina" class="p-2">
                  <!-- <font-awesome-icon :icon="['fas', 'angle-down']" /> -->
                  <img
                    src="@/assets/nav/down_blue.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="down arrow"
                  />
                </div>
                <div v-else class="p-2">
                  <!-- <font-awesome-icon :icon="['fas', 'angle-up']" /> -->
                  <img
                    src="@/assets/nav/up_blue.svg"
                    class="w-[16px] h-[16px] object-contain text-white"
                    alt="up arrow"
                  />
                </div>
              </div>
              <div v-show="syllabusAccordina === item.id" class="syllabus">
                <div
                  class="text-start text-md pl-6 pt-2 font-medium"
                  v-html="item.content"
                ></div>
              </div>
            </div>
            <div
              class="lg:flex lg:flex-row-reverse w-full justify-end lg:gap-4 items-center"
            >
              <div
                class="text-xs w-[22rem] md:w-full md:pl-2 m-auto text-center lg:text-start"
              >
                * Master Thesis / Project will be carried out between Sem 3 and
                Sem 4, but evaluation will reflect in Sem 4
              </div>
              <div
                v-if="electiveData[0].brochure_url"
                @click="handleDownloadClick"
                class="bg-[#F8C300] w-[20rem] m-auto rounded-full py-3 px-16 lg:px-10 lg:text-xs xl:text-[16px] font-bold mt-4 lg:mt-0 cursor-pointer"
              >
                Download Brochure
              </div>
            </div>
            <!-- {{ electiveData[0].brochure_url }} -->
          </div>

          <div class="relative m-auto mt-[8rem] md:ml-10 md:mt-[6rem]">
            <div
              class="bg-gradient-to-b from-[#0F2689] to-[#062157] w-[22rem] lg:w-full mb-[4rem] flex flex-col justify-center items-center rounded-lg"
            >
              <div class="absolute top-[-25%] lg:hidden">
                <img
                  src="@/assets/electiveDetail/tabletMobile.png"
                  alt="mobile"
                  class="object-contain"
                />
              </div>
              <div class="absolute top-[-35%] hidden lg:block">
                <img
                  src="@/assets/electiveDetail/tabletDes.png"
                  alt="mobile"
                  class="object-contain"
                />
              </div>
              <div class="text-[#F8C300] mt-4 text-2xl font-bold pt-[4rem]">
                Our Cutting-Edge LMS
              </div>
              <div class="text-center text-sm md:text-lg text-white p-4">
                Explore our innovative platform that offers a dynamic and
                interactive learning experience with advanced features tailored
                to enhance collaboration, engagement, and knowledge retention,
                positioning you for a transformative educational journey unlike
                any other.
              </div>
              <!-- <a href=" https://learn.onlinejain.com/" target="_blank">
                <div
                  class="bg-[#F8C300] rounded-full py-3 px-16 font-bold mt-4 mb-4"
                >
                  Explore Now
                </div>
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--syllabus-->
    <!--our Academic approch-->
    <div class="m-auto md:pt-[40px]">
      <div class="overflow-x-hidden">
        <h2 class="text-2xl font-bold w-[12rem] md:w-max m-auto md:text-3xl">
          Our Academic Approach
        </h2>
        <div class="text-center mt-4 px-8 py-2 m-auto 2xl:text-xl max-w-5xl">
          Explore our dynamic educational framework, thoughtfully engineered to
          optimize your learning journey, fostering accessibility, flexibility,
          immersion, and enrichment.
        </div>
        <div
          class="bg-[#001C54] mt-16 relative h-[18rem] md:h-[10rem] rounded-t-2xl"
        >
          <div class="flex flex-col flex-wrap mb-8 justify-center items-center">
            <div
              class="flex gap-x-8 flex-wrap justify-center gap-y-4 w-[22rem] md:w-max absolute top-[-14%] md:top-[-26%] md:right-[5%] lg:right-[17%] xl:right-[26%] 2xl:right-[32%] xxl:right-[35%]"
            >
              <div
                class="bg-[#FFFFFF] p-4 flex items-center justify-center flex-col shadow-xl w-[10rem] rounded-lg"
              >
                <img
                  src="@/assets/electiveDetail/technicalEvolution.png"
                  alt="technicalEvolution"
                />
                <div class="text-xs pt-4">
                  Teaching Learning and
                  <br />
                  Evaluation Plan (TLEP)
                </div>
              </div>
              <div
                class="bg-[#FFFFFF] p-4 flex items-center justify-center flex-col shadow-xl w-[10rem] rounded-lg"
              >
                <img
                  src="@/assets/electiveDetail/microLesson.png"
                  alt="microlesson"
                />
                <div class="text-xs pt-4">Micro-lessons</div>
              </div>
              <div
                class="bg-[#FFFFFF] p-4 flex items-center justify-center flex-col shadow-xl w-[10rem] rounded-lg"
              >
                <img
                  src="@/assets/electiveDetail/virtualLab.png"
                  alt="virtuallab"
                />
                <div class="text-xs pt-4">
                  Virtual
                  <br />
                  Laboratories
                </div>
              </div>
              <div
                class="bg-[#FFFFFF] p-4 flex items-center justify-center flex-col shadow-xl w-[10rem] rounded-lg"
              >
                <img
                  src="@/assets/electiveDetail/tap-R-model.png"
                  alt="tap-R-model"
                />
                <div class="text-xs pt-4">TAP-R Model</div>
              </div>
            </div>
            <div
              class="absolute lg:right-0 xl:right-[10%] 2xl:right-[400px] lg:top-[-60px] md:right-0 right-[-24%] -z-10 lg:z-10"
            >
              <img
                src="@/assets/electiveDetail/Path.png"
                alt=""
                class="lg:w-[170px] w-[156px]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--our Academic approch-->
    <!--Microcredentsial course-->
    <!-- <div class="mt-[3rem]">
      <div class="max-w-7xl m-auto">
        <div class="relative">
          <h1
            class="text-start w-[10rem] pl-4 text-2xl font-bold md:w-max md:text-xl lg:text-3xl"
          >
            Access to Microcredential Courses
          </h1>
          <div
            class="pl-4 pt-4 xl:text-xl text-start w-[20rem] md:w-[45rem] lg:w-[60rem] xl:w-[73rem]"
          >
            Enhance your skills and earn extra credits with our short-term
            microcredential courses. These focused programs cover emerging
            areas, advanced technologies, and essential soft skills, empowering
            you to develop competencies for career advancement.
          </div>
          <div
            class="text-end pr-6 text-[#001C54] text-lg absolute top-[80%] lg:top-20 right-0 font-semibold cursor-pointer"
          >
            <span class="underline decoration-[#F8C300] decoration-2">
              See All
            </span>
          </div>
        </div>
        <div>
          <div class="micro_cred flex justify-center items-center">
            <div
              v-for="(update, index) in updates"
              :key="index"
              class="text-left p-[2rem]"
            >
              <div class="flex justify-center">
                <div
                  class="w-[300px] h-[160px] md:w-[300px] md:h-[170px] lg:w-[390px] lg:h-[180px]"
                >
                  <div
                    class="border shadow-xl px-[15px] py-[14px] lg:px-[35px] lg:py-[28px] rounded-xl bg-white flex flex-col gap-[6px] md:gap-5"
                  >
                    <h3 class="text-[18px] text-[#1f1f1f]">
                      {{ update.content }}
                    </h3>

                    <p
                      class="flex gap-3 items-center text-[14px] text-[#1f1f1f]"
                    >
                      <img
                        src="@/assets/electiveDetail/linkedin.jpg"
                        alt="linkedin"
                      />
                      <span>
                        <img
                          src="@/assets/OtherPages/Icon-feather-arrow-up-right.svg"
                          class="w-3 object-contain cursor-pointer"
                          alt="redirect to linkedIn"
                        />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--Microcredentsial course-->
    <!-- <Resources> -->

    <section
      v-if="electiveBookdata.length"
      class="w-full mx-auto max-w-7xl my-20"
    >
      <div>
        <h2 class="text-2xl font-bold md:text-3xl text-left px-5">
          Download our free eBook and White Paper Documents
        </h2>
        <div class="flex lg:justify-between items-center lg:items-end">
          <p class="text-black text-left py-3 px-5 w-[340px] lg:w-[920px]">
            Check out the latest eBooks and White Paper Documents on various
            online degree programs we provide. Download Now!
          </p>
          <a href="/news-media">
            <button
              class="text-[16px] text-[#001C54] font-bold underline decoration-2 decoration-[#F8C300] underline-offset-4 mr-3"
            >
              See All
            </button>
          </a>
        </div>
      </div>

      <div class="py-5">
        <div class="slick_book">
          <div
            class="w-[430px] h-[200px] bg-white drop-shadow-2xl rounded-2xl p-5 border my-1"
            v-for="(item, index) in electiveBookdata"
            :key="index"
          >
            <div class="flex gap-5">
              <img :src="item.image" alt="resource" class="h-[150px]" />
              <div class="flex flex-col gap-7 items-start">
                <p class="text-[#07215D] !font-bold text-md text-left h-[95px]">
                  {{ item.title }}
                </p>
                <button
                  class="bg-[#F8C300] px-8 py-1 font-bold rounded-full w-[150px]"
                  @click="toggleFormVisibility(item.ebook, item.description)"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <Resources> -->
    <!--who can apply-->
    <div class="mt-[4rem]">
      <div
        class="max-w-7xl 2xl:max-w-screen-2xl m-auto flex justify-center px-8 md:px-0"
      >
        <div
          class="shadow-xl bg-[#FFFFFF] p-4 md:p-8 w-[22rem] md:w-[45rem] lg:w-[55rem] xl:w-[75rem] 2xl:w-[85rem] mb-4 rounded-lg relative border"
        >
          <div>
            <h2
              class="text-[24px] text-black lg:text-3xl font-bold md:text-start"
            >
              Who Can Apply
            </h2>
            <h3
              class="font-semibold pt-2 md:text-start lg:text-xl text-[#1F1F1F]"
            >
              Eligibility
            </h3>
          </div>
          <div>
            <div class="flex pt-4 gap-x-4">
              <div
                class="text-start text-sm lg:text-lg w-[17rem] md:w-[30rem] lg:w-[40rem] eligibility"
                v-html="electiveData[0].eligibility_description"
              ></div>
            </div>
            <div @click="handleApplyNowApply">
              <button
                class="bg-[#F8C300] my-4 w-max m-auto px-20 py-3 rounded-full font-bold cursor-pointer md:hidden"
              >
                Apply Now
              </button>
            </div>
          </div>
          <div class="absolute -right-0 -top-0 md:-top-10">
            <img
              src="@/assets/electiveDetail/Path550.svg"
              alt=""
              class="lg:w-[269px] w-[58px]"
            />
          </div>
        </div>
      </div>
    </div>
    <!--who can apply-->
    <!--fee Structure-->
    <div class="mt-[3rem]">
      <div class="max-w-7xl 2xl:max-w-screen-2xl m-auto">
        <div>
          <div>
            <h2 class="font-bold text-[35px] text-black hidden md:block">
              Fee Structure
            </h2>
            <!-- mobile -->
            <h2 class="font-bold text-[24px] text-black block md:hidden">
              Fee Plan
            </h2>
            <!-- mobile -->
            <h3 class="font-medium text-black">
              Compare and choose a plan that suits you
            </h3>
          </div>

          <div class="mt-2 mb-4">
            <div class="flex justify-center gap-x-4">
              <div
                @click="feePlanTab = 'national'"
                class="cursor-pointer"
                :class="
                  feePlanTab == 'national'
                    ? 'underline decoration-[#F8C300] decoration-2 '
                    : ''
                "
              >
                National
              </div>
              <div
                v-if="electiveData[0].international_year_total_fee"
                @click="feePlanTab = 'International'"
                class="cursor-pointer"
                :class="
                  feePlanTab == 'International'
                    ? 'underline decoration-[#F8C300] decoration-2 '
                    : ''
                "
              >
                International
              </div>
            </div>
          </div>
        </div>
        <!--content-->
        <div v-if="feePlanTab == 'national'">
          <div
            class="p-2 lg:p-4 flex justify-center flex-col lg:flex-row gap-2 xl:gap-4 items-center"
          >
            <div
              v-if="electiveData[0]?.indian_emi_fee"
              class="bg-[#001C54] w-[90%] lg:w-[18rem] rounded-lg shadow-xl flex flex-col justify-center items-center h-[150px]"
            >
              <div class="mt-8">
                <p class="text-white font-semibold text-2xl">EMI starting</p>
                <p class="text-[#F8C300] font-semibold text-xl">
                  INR
                  {{ formatCurrency(electiveData[0].indian_emi_fee) }}/month*
                </p>
              </div>
              <div class="flex gap-20 px-3 py-2">
                <div class="flex items-center gap-2">
                  <p class="text-white text-xs">0% interest</p>
                </div>
                <div class="flex items-center gap-2">
                  <p class="text-white text-xs">No Hidden Costs</p>
                </div>
              </div>
            </div>
            <div
              class="bg-white w-[90%] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
              v-if="electiveData[0].indian_semester_fee"
            >
              <h3 class="text-start text-[16px] font-medium p-2 text-black">
                Semester Fee
              </h3>
              <div v-if="electiveData[0].indian_semester_affiliation_fee">
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrency(totalSemesterFee) }}
                </p>
                <p>
                  (
                  {{ formatCurrency(electiveData[0]?.indian_semester_fee) }} +
                  {{
                    formatCurrency(
                      electiveData[0]?.indian_semester_affiliation_fee
                    )
                  }}<sup>*</sup>
                  )
                </p>
              </div>
              <div v-else>
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrency(electiveData[0]?.indian_semester_fee) }}
                </p>
              </div>
              <p class="text-[#555555] text-start font-medium px-2 py-2">
                x {{ electiveData[0].semester }} Semesters
              </p>
            </div>
            <div
              class="bg-white w-[90%] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
              v-if="electiveData[0].indian_year_fee"
            >
              <h3 class="text-start text-[16px] font-medium p-2 text-black">
                Year Fee
              </h3>
              <div v-if="electiveData[0].indian_year_affiliation_fee">
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrency(totalYearFee) }}
                </p>
                <p>
                  ({{ formatCurrency(electiveData[0].indian_year_fee) }} +
                  {{
                    formatCurrency(
                      electiveData[0]?.indian_year_affiliation_fee
                    )
                  }}<sup>*</sup>)
                </p>
              </div>
              <div v-else>
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrency(electiveData[0].indian_year_fee) }}
                </p>
              </div>
              <p
                v-if="electiveData[0].indian_semester_fee"
                class="text-[#555555] text-start font-medium px-2 py-2"
              >
                x {{ electiveData[0].duration }} Years
              </p>
            </div>
            <div
              class="bg-white w-[90%] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
            >
              <h3 class="text-start text-[16px] text-black font-medium p-2">
                Total Fee
              </h3>
              <div v-if="electiveData[0].indian_year_total_affiliation_fee">
                <p
                  class="text-4xl text-[#001C54] text-start font-bold px-2 pb-1"
                >
                  {{ formatCurrency(totalFee) }}
                </p>
                <p>
                  ({{ formatCurrency(electiveData[0]?.indian_year_total_fee) }}
                  +
                  {{
                    formatCurrency(
                      electiveData[0]?.indian_year_total_affiliation_fee
                    )
                  }}<sup>*</sup>)
                </p>
              </div>
              <div v-else>
                <p
                  class="text-4xl text-[#001C54] text-start font-bold px-2 pb-3"
                >
                  {{ formatCurrency(electiveData[0]?.indian_year_total_fee) }}
                </p>
              </div>
            </div>
            <p
              v-if="electiveData[0].note"
              class="text-black font-bold pb-2 md:hidden text-sm"
            >
              {{ electiveData[0].note }}
            </p>
            <div
              v-if="
                $route.path !==
                '/online-mcom/professional-accounting-and-finance'
              "
              class="w-[90%] p-1 text-start text-[#555555] text-xs mt-2 lg:hidden"
            >
              One time university registration fee during Admission: ₹2500/-
              <br />
              Examination Fee per year: ₹3000/-
              <br />
              <span
                v-if="
                  $route.path !==
                  '/online-ma/jainology-comparative-religions-philosophy'
                "
                >For SAARC countries, Registration Fee Per Year: ₹ 11250/- and
                Exam Fee Per Year: ₹ 3750/-</span
              >
              <br />
              Fee applicable to students from India and SAARC countries only
              <br />
            </div>
            <div
              v-if="shouldDisplayContactInfo"
              class="text-start text-[#555555] w-[45rem] m-auto md:hidden text-xs"
            >
              <div class="flex justify-start items-center gap-2 pt-2">
                <img
                  src="@/assets/electiveDetail/Phone.webp"
                  alt="phone"
                  class="w-5"
                />
                <p>
                  Contact
                  <span class="text-[#001C54]"
                    ><a :href="'tel:' + contactNumber">{{
                      contactNumber
                    }}</a></span
                  >
                  for any query related to the program
                </p>
              </div>
              <div class="flex justify-start items-center gap-2 pt-2">
                <img
                  src="@/assets/electiveDetail/Email-Button.webp"
                  alt="phone"
                  class="w-5"
                />
                <p>
                  Email us at
                  <a :href="emailHref" class="text-[#001C54]"
                    >online.gl@jainuniversity.ac.in</a
                  >
                </p>
              </div>
            </div>
          </div>
          <p
            v-if="electiveData[0].note"
            class="text-black font-bold pb-2 hidden md:block"
          >
            {{ electiveData[0].note }}
          </p>
          <div
            v-if="
              $route.path !== '/online-mcom/professional-accounting-and-finance'
            "
            class="text-center text-[#555555] w-[45rem] m-auto hidden lg:block text-sm"
          >
            One time university registration fee during Admission:
            {{
              formatCurrency(
                electiveData[0].indian_university_registration_fee
              )
            }}/- Examination Fee per year:
            {{ formatCurrency(electiveData[0].indian_yearly_exam_fee) }}/-
            <br />
            <span
              v-if="
                $route.path !==
                '/online-ma/jainology-comparative-religions-philosophy'
              "
              >For SAARC countries, Registration Fee Per Year: ₹ 11,250/- and
              Exam Fee Per Year: ₹ 3,750/-</span
            >
            <br />Fee applicable to students from India and SAARC countries only
          </div>
          <div></div>
          <div
            v-if="shouldDisplayContactInfo"
            class="text-center text-[#555555] w-[45rem] m-auto hidden lg:block text-sm"
          >
            <div class="flex justify-center items-center gap-2 pt-2">
              <img
                src="@/assets/electiveDetail/Phone.webp"
                alt="phone"
                class="w-5"
              />
              <p>
                Contact
                <span class="text-[#001C54]"
                  ><a :href="'tel:' + contactNumber">{{
                    contactNumber
                  }}</a></span
                >
                for any query related to the program
              </p>
            </div>
            <div class="flex justify-center items-center gap-2 pt-2">
              <img
                src="@/assets/electiveDetail/Email-Button.webp"
                alt="phone"
                class="w-5"
              />
              <p>
                Email us at
                <a :href="emailHref" class="text-[#001C54]"
                  >online.gl@jainuniversity.ac.in</a
                >
              </p>
            </div>
          </div>
        </div>
        <div v-if="feePlanTab == 'International'">
          <div
            class="p-2 lg:p-4 flex justify-center flex-col lg:flex-row gap-2 xl:gap-4 items-center"
          >
            <!-- <div class="bg-[#001C54] w-[90%] lg:w-[18rem] rounded-lg shadow-xl">
              <div class="p-2 rounded-lg">
                <img
                  src="@/assets/electiveDetail/liquiloans.jpg"
                  class="rounded-lg"
                  alt="liquiloanse"
                />
              </div>
              <div class="text-start p-2 font-bold text-white">
                EMI starting at
              </div>
              <div
                class="text-4xl lg:text-2xl px-2 font-bold text-start text-[#F8C300]"
              >
                {{
                  formatCurrencyDollar(electiveData[0].international_emi_fee)
                }}
                /month
              </div>
              <div class="flex gap-x-4 px-3 py-2">
                <div class="flex items-center gap-2">
                  <div>
                    <img
                      src="@/assets/electiveDetail/checkmarkIcons.svg"
                      alt="checkmarkIcons"
                    />
                  </div>
                  <div class="text-white text-xs">0% interest</div>
                </div>
                <div class="flex items-center gap-2">
                  <div>
                    <img
                      src="@/assets/electiveDetail/checkmarkIcons.svg"
                      alt="checkmarkIcons"
                    />
                  </div>
                  <div class="text-white text-xs">No Hidden Costs</div>
                </div>
              </div>
            </div> -->
            <div
              class="bg-white w-[20rem] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
              v-if="electiveData[0]?.international_semester_fee"
            >
              <h3 class="text-start text-[16px] text-black font-medium p-2">
                Semester Fee
              </h3>
              <div v-if="electiveData[0].international_semester_affliation_fee">
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrencyDollar(totalInternationalSemesterFee) }}
                </p>
                <p>
                  ({{
                    formatCurrencyDollar(
                      electiveData[0]?.international_semester_fee
                    )
                  }}
                  +
                  {{
                    formatCurrencyDollar(
                      electiveData[0]?.international_semester_affliation_fee
                    )
                  }}<sup>*</sup>)
                </p>
              </div>
              <div v-else>
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{
                    formatCurrencyDollar(
                      electiveData[0].international_semester_fee
                    )
                  }}
                </p>
              </div>
              <div class="text-[#555555] text-start font-medium px-2 py-2">
                x {{ electiveData[0]?.semester }} Semesters
              </div>
            </div>
            <div
              class="bg-white w-[20rem] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
              v-if="electiveData[0]?.international_year_fee"
            >
              <h3 class="text-start text-[16px] text-black font-medium p-2">
                Year Fee
              </h3>
              <div v-if="electiveData[0].international_year_affliation_fee">
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{ formatCurrencyDollar(totalInternationalYearFee) }}
                </p>
                <p>
                  ({{
                    formatCurrencyDollar(
                      electiveData[0]?.international_year_fee
                    )
                  }}
                  +
                  {{
                    formatCurrencyDollar(
                      electiveData[0]?.international_year_affliation_fee
                    )
                  }}<sup>*</sup>)
                </p>
              </div>
              <div v-else>
                <p class="text-4xl text-[#001C54] text-start font-bold px-2">
                  {{
                    formatCurrencyDollar(electiveData[0].international_year_fee)
                  }}
                </p>
              </div>
              <div
                v-if="electiveData[0].international_semester_fee"
                class="text-[#555555] text-start font-medium px-2 py-2"
              >
                x {{ electiveData[0]?.duration }} Years
              </div>
            </div>
            <div
              class="bg-white w-[20rem] lg:w-[18rem] lg:h-[10rem] shadow-xl mt-1 lg:mt-0 rounded-lg flex flex-col justify-start items-center h-[9rem]"
            >
              <h3 class="text-start text-[16px] text-black font-medium p-2">
                Total Fee
              </h3>
              <div
                v-if="electiveData[0].international_year_total_affliation_fee"
              >
                <p
                  class="text-4xl text-[#001C54] text-start font-bold px-2 pb-1"
                >
                  {{ formatCurrencyDollar(totalInternationalYearTotalFee) }}
                </p>
                <p>
                  ({{
                    formatCurrencyDollar(
                      electiveData[0]?.international_year_total_fee
                    )
                  }}
                  +
                  {{
                    formatCurrencyDollar(
                      electiveData[0]?.international_year_total_affliation_fee
                    )
                  }}<sup>*</sup>)
                </p>
              </div>
              <div v-else>
                <p
                  class="text-4xl text-[#001C54] text-start font-bold px-2 pb-1"
                >
                  {{
                    formatCurrencyDollar(
                      electiveData[0].international_year_total_fee
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="lg:hidden">
              <p
                v-if="electiveData[0].note"
                class="text-black font-bold pb-2 text-sm"
              >
                {{ electiveData[0].note }}
              </p>
            </div>
            <div
              v-if="
                $route.path !==
                '/online-mcom/professional-accounting-and-finance'
              "
              class="w-[20rem] p-1 text-start text-[#555555] text-sm mt-2 lg:hidden"
            >
              One time university registration fee during Admission:
              {{
                formatCurrencyDollar(
                  electiveData[0].international_university_registration_fee
                )
              }}/-
            </div>
            <div
              v-if="
                $route.path !==
                '/online-mcom/professional-accounting-and-finance'
              "
              class="w-[20rem] p-1 text-start text-[#555555] text-sm lg:hidden"
            >
              Examination Fee per year:
              {{
                formatCurrencyDollar(
                  electiveData[0].international_yearly_exam_fee
                )
              }}/-
            </div>
            <div
              v-if="shouldDisplayContactInfo"
              class="text-start text-[#555555] w-[45rem] m-auto md:hidden text-xs"
            >
              <div class="flex justify-start items-center gap-2 pt-2">
                <img
                  src="@/assets/electiveDetail/Phone.webp"
                  alt="phone"
                  class="w-5"
                />
                <p>
                  Contact
                  <span class="text-[#001C54]"
                    ><a :href="'tel:' + contactNumber">{{
                      contactNumber
                    }}</a></span
                  >
                  for any query related to the program
                </p>
              </div>
              <div class="flex justify-start items-center gap-2 pt-2">
                <img
                  src="@/assets/electiveDetail/Email-Button.webp"
                  alt="phone"
                  class="w-5"
                />
                <p>
                  Email us at
                  <a :href="emailHref" class="text-[#001C54]"
                    >online.gl@jainuniversity.ac.in</a
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="hidden lg:block">
            <p v-if="electiveData[0].note" class="text-black font-bold pb-2">
              {{ electiveData[0].note }}
            </p>
          </div>
          <div
            v-if="
              $route.path !== '/online-mcom/professional-accounting-and-finance'
            "
            class="text-center text-[#555555] w-[45rem] m-auto hidden lg:block text-sm"
          >
            One time university registration fee during Admission:
            {{
              formatCurrencyDollar(
                electiveData[0].international_university_registration_fee
              )
            }}/- Examination Fee per year:
            {{
              formatCurrencyDollar(
                electiveData[0].international_yearly_exam_fee
              )
            }}/-
          </div>
          <div
            v-if="shouldDisplayContactInfo"
            class="text-center text-[#555555] w-[45rem] m-auto hidden lg:block text-sm"
          >
            <div class="flex justify-center items-center gap-2 pt-2">
              <img
                src="@/assets/electiveDetail/Phone.webp"
                alt="phone"
                class="w-5"
              />
              <p>
                Contact
                <span class="text-[#001C54]"
                  ><a :href="'tel:' + contactNumber">{{
                    contactNumber
                  }}</a></span
                >
                for any query related to the program
              </p>
            </div>
            <div class="flex justify-center items-center gap-2 pt-2">
              <img
                src="@/assets/electiveDetail/Email-Button.webp"
                alt="phone"
                class="w-5"
              />
              <p>
                Email us at
                <a :href="emailHref" class="text-[#001C54]"
                  >online.gl@jainuniversity.ac.in</a
                >
              </p>
            </div>
          </div>
        </div>
        <!--content-->
      </div>
    </div>
    <!--fee Structure-->

    <!-- italladdsup -->
    <div>
      <ItAllAddsUpView />
    </div>
    <!-- italladdsup -->
    <!-- Addmission process -->
    <div>
      <AdmissionProcess :widget_id="this.elecFaq.widget_id" />
    </div>

    <!-- dreams View -->
    <div>
      <DreamsView :widget_id="this.elecFaq.widget_id" />
    </div>
    <!-- ElectiveOutcomes -->
    <div>
      <div class="w-full md:flex md:justify-center py-4 md:py-8">
        <section class="w-full max-w-7xl mx-auto px-5 py-2 md:p-5 2xl:p-0">
          <div
            class="max-w-6xl mx-auto flex flex-col gap-5 lg:flex-row lg:justify-between"
          >
            <div class="lg:py-[33px] text-left hidden lg:block">
              <h2 class="text-[35px] text-[#1f1f1f] font-semibold py-5">
                Elective Outcomes
              </h2>
              <div class="w-full lg:w-[540px]">
                <ul
                  v-for="item in electiveData[0].takeaway"
                  :key="item"
                  class="list-disc text-[16px] md:text-[20px] text-[#1f1f1f] flex flex-col gap-4 px-6"
                >
                  <li>
                    {{ replaceDollarWithComma(item) }}
                  </li>
                </ul>
              </div>
            </div>

            <h2
              class="block lg:hidden text-left !font-bold text-[24px] md:text-[28px] text-[#1f1f1f]"
            >
              Elective Outcomes
            </h2>
            <div class="lg:w-[540px] lg:h-[490px]">
              <img
                src="@/assets/electiveDetail/career&addsup/Elective-outcomes-desktop.webp"
                alt=""
                class="w-full h-full md:object-fit lg:object-contain"
              />
            </div>
            <div class="w-full lg:w-[540px] lg:hidden block">
              <ul
                v-for="item in electiveData[0].takeaway"
                :key="item"
                class="list-disc text-[16px] md:text-[20px] text-left text-[#1f1f1f] flex flex-col gap-4 px-6"
              >
                <li>
                  {{ replaceDollarWithComma(item) }}
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- careerView -->
    <div>
      <CareerView />
    </div>
    <!-- compainesView -->
    <div>
      <OurAlumni />
    </div>
    <!-- aluminaiview -->
    <div>
      <AluminaiView />
    </div>
    <!-- Elective Faq -->
    <div>
      <FaqElective :faq="this.elecFaq" />
    </div>
    <div>
      <FooterView />
    </div>
    <!-- floating contact elements -->
    <SocialMedia />
    <!-- <DownloadBrochureElectiveVue
      v-show="is_download_widget == true"
      :widget_id="electiveData[0].widget_id"
      @close-widget="is_download_widget = false"
    /> -->
    <div v-if="this.electiveData">
      <BrochureElectiveView
        :url="electiveData[0].brochure_url"
        :elective="electiveData[0].slug"
        :program="electiveData[0].short_slug"
        :elective_data="electiveData[0]"
        v-show="is_download_widget == true"
        @close-button="is_download_widget = false"
      />
    </div>
    <!-- Popup Form Component -->
    <DocumentView
      v-if="showBookForm"
      @close-button="changeValue"
      :url="selectedEbook"
      :description="selectedCategory"
    />
    <ApplyView v-if="showApplyForm" @close="showApplyForm = false" />
  </div>
</template>

<script>
import NavigationView from "@/components/NavigationView.vue";
import ItAllAddsUpView from "@/components/ElectiveDetails/ItAllAddsUpView.vue";
import AdmissionProcess from "@/components/ElectiveDetails/AddmissionProcess.vue";
import DreamsView from "@/components/ElectiveDetails/DreamsView.vue";
import CareerView from "@/components/ElectiveDetails/CareerView.vue";
import OurAlumni from "@/components/ElectiveDetails/OurAlumni.vue";
import AluminaiView from "@/components/Home/AluminaiView.vue";
// import ElectiveFaq from "@/components/ElectiveListing/ElectiveFaq.vue";
import FaqElective from "@/components/ElectiveListing/FaqElective.vue";
import FooterView from "@/components/Home/FooterView.vue";
import SocialMedia from "@/components/SocialMedia.vue";
// import DownloadBrochureElectiveVue from "@/components/DownloadBrochureElective.vue";
import BrochureElectiveView from "../components/BrochureElectiveView.vue";
import ApplyView from "@/components/ApplyformView.vue";
import CertificateView from "@/components/CertificateView.vue";
import DocumentView from "@/components/ElectiveDetails/FormView.vue";
import $ from "jquery";
import "slick-carousel";
import axios from "axios";

export default {
  name: "ElectiveDetail",
  components: {
    NavigationView,
    ItAllAddsUpView,
    AdmissionProcess,
    DreamsView,
    CareerView,
    OurAlumni,
    AluminaiView,
    // ElectiveFaq,
    FaqElective,
    FooterView,
    SocialMedia,
    // DownloadBrochureElectiveVue,
    BrochureElectiveView,
    ApplyView,
    CertificateView,
    DocumentView,
  },
  data() {
    return {
      credit: null,
      course: "",
      is_download_widget: false,
      syllabusAccordina: null,
      feePlanTab: "national",
      updates: [
        {
          content:
            "YourStory - Revolutionizing Education: How Jain University, Kyndryl and USDC are Changing The Game",
        },
        {
          content:
            "News by Careers 360 - JAIN Online introduces MBA in International Finance",
        },

        {
          content:
            "Kyndryl - USDC Collaborates with Kyndryl to Develop “University-in-a-Box” for India’s Higher Education Sector",
        },
        {
          content:
            "CENTER FOR MANAGEMENT STUDIES has released the results for all degree programmes",
        },
        {
          content:
            "Kyndryl - USDC Collaborates with Kyndryl to Develop “University-in-a-Box” for India’s Higher Education Sector",
        },
        {
          content:
            "CENTER FOR MANAGEMENT STUDIES has released the results for all degree programmes",
        },
      ],
      electiveData: [],
      electiveSyllabus: [],
      electiveBookdata: {
        description: "",
      },
      elecFaq: "",
      urlsToHide: [
        "/online-mba/data-science",
        "/online-mba/digital-marketing-and-ecommerce",
        "/online-bba/digital-marketing",
        "/online-bba/data-science-and-analytics",
        "/online-mca/full-stack-development",
        "/online-mca/cloud-computing",
        "/online-mca/data-science",
        "/online-mca/artificial-intelligence",
      ],
      urlsToShow: [
        "/online-mba/data-science",
        "/online-mba/digital-marketing-and-ecommerce",
        "/online-bba/digital-marketing",
        "/online-bba/data-science-and-analytics",
        "/online-mca/full-stack-development",
        "/online-mca/cloud-computing",
        "/online-mca/data-science",
        "/online-mca/artificial-intelligence",
      ],
      contactNumbers: {
        "online-mba": "8047 184 883",
        "online-bba": "8045 681 263",
        "online-mca": "8047 184 884",
      },
      emailAddresses: {
        default: "online.gl@jainuniversity.ac.in",
      },
      elecFaq: {
        program: {
          category: {
            name: "",
          },
        },
      },
      credit: 0,
      showBookForm: false,
      selectedEbook: null,
      selectedCategory: null,
      showApplyForm: false,
    };
  },
  props: ["short_slug", "elective_slug"],

  async created() {
    await this.electiveInfo();

    if (this.electiveData != "") {
      this.electiveSyllabusInfo(this.electiveData[0].id);
    }
    this.checkingCredit();
    await this.trackingUser();
    if (this.electiveData && this.elecFaq && this.electiveData.length > 0) {
      const electiveTitle = this.electiveData[0].sub_name
        ? this.electiveData[0].sub_name.replace(/<[^>]*>/g, "")
        : "";
      const electiveDetail = this.electiveData[0].description
        ? this.electiveData[0].description.replace(/<[^>]*>/g, "")
        : "";

      let tags = [];
      if (this.electiveData[0].trending) {
        tags.push("Most popular elective");
      }
      tags.push("Only few seats left");

      dataLayer.push({
        event: "Elective Viewed",
        Attribute: {
          "Elective Title": electiveTitle,
          "Elective ID": this.electiveData[0].order
            ? this.electiveData[0].order.toString()
            : "",
          Program: this.electiveData[0].program.name || "",
          "Program ID": this.electiveData[0].program.id
            ? this.electiveData[0].program.id.toString()
            : "",
          Domain: this.electiveData[0].program.category.name || "",
          "Domain ID": this.electiveData[0].program.category.id
            ? this.electiveData[0].program.category.id.toString()
            : "",
          "Elective Details": electiveDetail,
          "Batch Start Date": this.electiveData[0].next_batch || "",
          Duration: this.electiveData[0].duration
            ? `${this.electiveData[0].duration} years`
            : "",
          Tags: tags.join(", "),
          "CTA Section": "Navigation Bar",
        },
      });
    }
  },
  computed: {
    shouldDisplay() {
      const currentPath = this.$route.path;
      return !this.urlsToHide.includes(currentPath);
    },
    totalSemesterFee() {
      const fee = Number(this.electiveData[0]?.indian_semester_fee) || 0;
      const affiliationFee =
        Number(this.electiveData[0]?.indian_semester_affiliation_fee) || 0;
      return fee + affiliationFee;
    },
    totalYearFee() {
      const fee = Number(this.electiveData[0]?.indian_year_fee) || 0;
      const affiliationFee =
        Number(this.electiveData[0]?.indian_year_affiliation_fee) || 0;
      return fee + affiliationFee;
    },
    totalFee() {
      const fee = Number(this.electiveData[0]?.indian_year_total_fee) || 0;
      const affiliationFee =
        Number(this.electiveData[0]?.indian_year_total_affiliation_fee) || 0;
      return fee + affiliationFee;
    },
    totalInternationalSemesterFee() {
      const fee = parseFloat(
        (this.electiveData[0]?.international_semester_fee || "0").replace(
          /,/g,
          ""
        )
      );
      const affiliationFee = parseFloat(
        (
          this.electiveData[0]?.international_semester_affliation_fee || "0"
        ).replace(/,/g, "")
      );
      return fee + affiliationFee;
    },
    totalInternationalYearFee() {
      const fee = parseFloat(
        (this.electiveData[0]?.international_year_fee || "0").replace(/,/g, "")
      );
      const affiliationFee = parseFloat(
        (
          this.electiveData[0]?.international_year_affliation_fee || "0"
        ).replace(/,/g, "")
      );
      return fee + affiliationFee;
    },
    totalInternationalYearTotalFee() {
      const fee = parseFloat(
        (this.electiveData[0]?.international_year_total_fee || "0").replace(
          /,/g,
          ""
        )
      );
      const affiliationFee = parseFloat(
        (
          this.electiveData[0]?.international_year_total_affliation_fee || "0"
        ).replace(/,/g, "")
      );
      return fee + affiliationFee;
    },
    feeLabel() {
      const currentUrl = window.location.href;
      const specificUrl1 = "/online-mcom/professional-accounting-and-finance";
      const specificUrl2 =
        "/online-ma/jainology-comparative-religions-philosophy";

      if (currentUrl.includes(specificUrl1)) {
        return "Yearly Fees";
      } else if (currentUrl.includes(specificUrl2)) {
        return "Total Fee";
      } else if (this.isParticularUrl()) {
        return "Program Fees";
      } else {
        return "Semester Fees";
      }
    },
    shouldDisplayContactInfo() {
      const shouldDisplay = this.urlsToShow.includes(this.$route.path);
      return shouldDisplay;
    },
    contactNumber() {
      const path = this.$route.path.split("/")[1];
      console.log("Extracted path:", path);
      const selectedNumber =
        this.contactNumbers[path] || this.defaultContactNumber;
      console.log("Selected contact number:", selectedNumber);
      return selectedNumber;
    },
    emailHref() {
      return `mailto:${
        this.emailAddresses[this.$route.path.split("/")[1]] ||
        this.emailAddresses["default"]
      }`;
    },
    showNoteForURL() {
      const currentPath = this.$route.path;
      const specificURLs = [
        "/online-mba/international-finance",
        "/online-bcom/international-finance-and-accounting",
        "/online-mcom/international-finance",
        "/online-bca/computer-science-and-information-technology",
      ];
      return specificURLs.includes(currentPath);
    },
    isSpecificRoute() {
      return (
        this.$route.path ===
        "/online-bca/computer-science-and-information-technology"
      );
      firstPart;
    },
    futureEmployability() {
      return this.electiveData.length > 0
        ? this.electiveData[0].future_employability
        : "";
    },
    employabilityData() {
      const splitData = (data) => {
        const parts = data.split(" || ");
        return parts.length === 1 ? ["", parts[0]] : parts;
      };

      const [firstEmployability, secondEmployability] = splitData(
        this.electiveData[0]?.future_employability || ""
      );
      const [firstOpenings, secondOpenings] = splitData(
        this.electiveData[0]?.future_openings || ""
      );
      const [firstGrowth, secondGrowth] = splitData(
        this.electiveData[0]?.future_growth || ""
      );

      return {
        firstEmployability,
        secondEmployability,
        firstOpenings,
        secondOpenings,
        firstGrowth,
        secondGrowth,
      };
    },
  },
  async mounted() {
    await this.electiveBookinfo();
    // $(`.micro_cred`).slick({
    //   infinite: true,
    //   autoplay: true,
    //   prevArrow: false,
    //   nextArrow: false,
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   dots: true,
    //   dotsClass: "slick-dotsMicroCredential",
    //   responsive: [
    //     {
    //       breakpoint: 1026,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 950,
    //       settings: {
    //         slidesToShow: 2,
    //         slidesToScroll: 1,
    //       },
    //     },
    //     {
    //       breakpoint: 650,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //       },
    //     },
    //   ],
    // });
    this.$nextTick(() => {
      this.initializeSlick();
    });
  },
  methods: {
    scroll() {
      const element = document.getElementById("highlights");
      element.scrollIntoView({ behavior: "smooth" });
    },
    replaceDollarWithComma(text) {
      // Replace $ with , in the data
      return text.replace(/\$/g, ",");
    },
    toggleFormVisibility(ebook, description) {
      // Your logic for toggling the form visibility
    },
    toggleAccordin(index) {
      if (index === this.syllabusAccordina) {
        this.syllabusAccordina = null;
      } else {
        this.syllabusAccordina = index;
      }
    },

    async electiveInfo() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/course/elective-list/?program__short_slug=${this.short_slug}&&slug=${this.elective_slug}`
        );
        if (response.data.status === 200) {
          this.electiveData = response.data.data;
          this.elecFaq = this.electiveData[0];
        } else {
          this.$router.push({
            name: "PageNotFound",
            params: { pathMatch: "page-not-found" },
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async electiveBookinfo() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/elective/e-book-list/?elective__short_slug=${this.short_slug}&&elective__slug=${this.elective_slug}`
        );

        if (response.data.status === 200) {
          this.electiveBookdata = response.data.data;
          if (
            Array.isArray(this.electiveBookdata) &&
            this.electiveBookdata.length > 0
          ) {
            this.$nextTick(() => {
              this.initializeSlick();
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    initializeSlick() {
      const slickContainer = $(".slick_book");

      if (slickContainer.hasClass("slick-initialized")) {
        slickContainer.slick("unslick");
      }
      slickContainer.slick({
        infinite: true,
        autoplay: true,
        prevArrow: false,
        nextArrow: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        dotsClass: "slick-dots",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 650,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
    destroySlick() {
      const slickContainer = $(".slick_book");
      if (slickContainer.hasClass("slick-initialized")) {
        slickContainer.slick("unslick");
      }
    },
    downloadResource() {
      console.log("Download clicked");
    },
    handleDownloadClick() {
      const { gl_status, gl_url } = this.electiveData[0];
      if (gl_status) {
        window.open(gl_url, "_blank");
      } else {
        this.is_download_widget = true;
      }
    },

    checkingCredit() {
      const currentUrl = window.location.pathname;

      const credit80Urls = [
        "/online-ma/jainology-comparative-religions-philosophy",
      ];

      const credit126Urls = [
        "/online-mba/data-science",
        "/online-mba/digital-marketing-and-ecommerce",
        "/online-bba/digital-marketing",
        "/online-bba/data-science-and-analytics",
      ];

      if (credit80Urls.includes(currentUrl)) {
        this.credit = 80;
      } else if (credit126Urls.includes(currentUrl)) {
        this.credit = 126;
      } else {
        if (this.elecFaq.program.category.name === "Masters") {
          this.credit = 90;
        } else {
          this.credit = 120;
        }
      }
    },

    async electiveSyllabusInfo(id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course/elective-syllabus-list/?elective__id=${id}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.electiveSyllabus = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async trackingUser() {
      if (window.location.origin === "https://onlinejain.com") {
        let trackingData = {
          elective_name: this.$route.params.elective_slug,
          elective_url: `${window.location.origin}${window.location.pathname}`,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_source: this.$route.query.utm_source || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_adgroup: this.$route.query.utm_adgroup || "",
          utm_location: this.$route.query.utm_location || "",
          utm_keyword: this.$route.query.utm_keyword || "",
          utm_device: this.$route.query.utm_device || "",
          utm_adgroupid: this.$route.query.utm_adgroupid || "",
          utm_matchype: this.$route.query.utm_matchype || "",
          utm_devicemodel: this.$route.query.utm_devicemodel || "",
          utm_placement: this.$route.query.utm_placement || "",
          utm_target: this.$route.query.utm_target || "",
          utm_term: this.$route.query.utm_term || "",
          utm_network: this.$route.query.utm_network || "",
          utm_creative: this.$route.query.utm_creative || "",
          utm_creativeid: this.$route.query.utm_creativeid || "",
          utm_campaignid: this.$route.query.utm_campaignid || "",
          gclid: this.$route.query.gclid || "",
          // ip: https://api.ipify.org?format=json || "",
        };
        await axios
          .post(
            `${process.env.VUE_APP_API}/elective-tracking-create/`,
            trackingData
          )
          .then((resp) => {
            if (resp) {
              console.log("Post method request : ", resp);
            }
          })
          .catch((err) => {
            console.log("post method is not posted : ", err);
          });
      }
    },
    formatCurrency(value) {
      // Assuming value is in rupees
      var amount = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(value);

      return amount;
    },
    formatCurrencyDollar(value) {
      // Parse value to ensure it's a number
      var numericValue = parseFloat(value);

      // Check if parsing was successful
      if (!isNaN(numericValue)) {
        // Assuming value is in dollars
        var options = {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
          minimumFractionDigits: 0,
        };

        var amount = new Intl.NumberFormat("en-US", options).format(
          numericValue
        );

        amount = amount.replace(/(\.[0-9]*[1-9])0+$/, "$1").replace(/\.$/, "");

        return amount;
      } else {
        return "Invalid value";
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { month: "long", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
    formatDatebanner(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("en-US", {
        month: "long",
        day: "2-digit",
      });
      const year = date.getFullYear();
      const suffix = this.getDaySuffix(day);
      const shortMonth = date.toLocaleString("en-US", { month: "short" });

      // Check if the month is June, July, or September
      let formattedMonth;
      if (shortMonth === "Jun") {
        formattedMonth = "June";
      } else if (shortMonth === "Jul") {
        formattedMonth = "July";
      } else if (shortMonth === "Sep") {
        formattedMonth = "Sept";
      } else {
        formattedMonth = shortMonth;
      }

      return `${day}${suffix} ${formattedMonth}, ${year}`;
    },
    getDaySuffix(day) {
      if (day >= 11 && day <= 13) {
        return "th";
      }
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    },
    isParticularUrl() {
      return window.location.href.includes("/online-mba/strategic-finance");
    },
    handleApplyNowClick() {
      dataLayer.push({
        event: "Apply Online Initiated",
        Attribute: {
          CTA: "Apply Now",
          "Section Name": "Electivepage Banner",
        },
      });
      console.log("window.dataLayer::::", window.dataLayer);
      if (this.elecFaq.widget_id != null && this.elecFaq.widget_id != "") {
        window.open(
          `https://application.onlinejain.com/?id=${this.elecFaq.widget_id}`,
          "_blank"
        );
      } else {
        window.open("https://application.onlinejain.com/", "_blank");
      }

      // const redirectUrl = this.dynamicHref();
      // if (redirectUrl) {
      //   window.open(redirectUrl, "_blank");
      // }
      // else {
      //   this.showApplyForm = true;
      // }
    },
    closeForm() {
      this.showApplyForm = false; // Hide the form
    },
    dynamicHref() {
      // const currentPath = this.$route.path;
      // if (currentPath === "/online-mba/data-science") {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html";
      // } else if (
      //   currentPath === "/online-mba/digital-marketing-and-ecommerce"
      // ) {
      //   return "https://onlinejain.com/gl/mba-data-science-digital-marketing-jain-registration.html";
      // } else if (currentPath === "/online-bba/digital-marketing") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html";
      // } else if (currentPath === "/online-bba/data-science-and-analytics") {
      //   return "https://onlinejain.com/gl/bba-degree-jain-online-registration.html";
      // } else if (currentPath === "/online-mca/full-stack-development") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html";
      // } else if (currentPath === "/online-mca/cloud-computing") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html";
      // } else if (currentPath === "/online-mca/data-science") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html";
      // } else if (currentPath === "/online-mca/artificial-intelligence") {
      //   return "https://onlinejain.com/gl/jain-online-master-of-computer-applications-registration.html";
      // } else {
      //   return null; // Return null if no matching URL is found
      //}
      return "https://application.onlinejain.com/";
    },
    handleApplyNowApply() {
      dataLayer.push({
        event: "Apply Online Initiated",
        Attribute: {
          CTA: "Apply Now",
          "Section Name": "Who Can Apply",
        },
      });
      if (this.elecFaq.widget_id != null && this.elecFaq.widget_id != "") {
        window.open(
          `https://application.onlinejain.com/?id=${this.elecFaq.widget_id}`,
          "_blank"
        );
      } else {
        window.open("https://application.onlinejain.com/", "_blank");
      }
    },
    handleDownloadClick() {
      const elective = this.electiveData[0];
      const electiveDescription = elective.description.replace(/<[^>]*>/g, "");
      dataLayer.push({
        event: "Brochure Download Clicked",
        Attribute: {
          "Elective Title": elective.name,
          "Elective ID": elective.order.toString(),
          Program: elective.program.name,
          "Program ID": elective.program.id.toString(),
          Domain: elective.program.category.name,
          "Domain ID": elective.program.category.id.toString(),
          "Elective Details": electiveDescription,
          Duration: this.electiveData[0].duration
            ? `${this.electiveData[0].duration} years`
            : "",
          "Batch Start Date": elective.next_batch,
          "CTA Section": "Download Brochure",
        },
      });
      const { gl_status, gl_url } = elective;
      if (gl_status) {
        window.open(gl_url, "_blank");
      } else {
        this.is_download_widget = true;
      }
    },
    toggleFormVisibility(ebookUrl, category) {
      this.selectedEbook = ebookUrl; // Set the selected ebook URL
      this.showBookForm = true; // Show the popup form
      this.selectedCategory = category;
    },
    changeValue() {
      this.showBookForm = false;
    },
  },
  watch: {
    electiveBookdata() {
      this.$nextTick(() => {
        this.initializeSlick();
      });
    },
  },
  beforeDestroy() {
    this.destroySlick();
  },
  updated() {
    this.$nextTick(() => {
      this.initializeSlick();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.destroySlick();
    next();
  },
};
</script>

<style scoped>
.eligibility li {
  padding-left: 24px;
  background: url(@/assets/electiveDetail/checked.svg) left 5px no-repeat;

  background-size: 20px;
  margin-bottom: 25px;
  list-style-type: none !important;
}

.slick-dotsMicroCredential {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 1rem 0;
  list-style-type: none;
}
.slick-dotsMicroCredential li {
  margin: 0 0.25rem;
}
.slick-dotsMicroCredential button {
  display: block;
  width: 0.75rem;
  height: 0.75rem;
  padding: 0;
  border: none;
  border-radius: 15px;
  background-color: silver;
  text-indent: -9999px;
}
.slick-dotsMicroCredential li.slick-active button {
  background-color: #f8c300;
  width: 1.5rem !important;
  height: 0.5rem;
}
.syllabus li {
  list-style: disc;
}
.slik_events {
  overflow: hidden;
  height: auto;
  position: relative;
}
</style>
